<script>
  import Layout from "../../Layout/Layout.svelte";
  import config from "../../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import FStyleRow from "./FStyleRow.svelte";
  import { Circle } from "svelte-loading-spinners";
  import { link } from "svelte-spa-router";
  import MenuHeading from "../../shared/MenuHeading.svelte";

  let products = null;
  let queryURL = "";

  /* Query Parameters, just CHANGE them and the query will be regenerated as well, NO need to change everything */
  let page = 1;
  let searchKey = "";
  let sortBy = "";
  let sortOrder = "";

  /* Ordering */
  let tableOrder = "asc";

  const fetchFStyles = () => {
    products = null;

    queryURL = `${$config.backendURL}/fstyles/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;
    queryURL += `&sortBy=${sortBy || "addedOn"}`;
    queryURL += `&sortOrder=${sortOrder || "desc"}`;

    axios
      .get(queryURL)
      .then((res) => {
        products = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSort = (by) => {
    tableOrder = tableOrder == "asc" ? "desc" : "asc";
    sortBy = by;
    sortOrder = tableOrder;
    fetchFStyles();
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchFStyles();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchFStyles();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = "";
    sortBy = "";
    sortOrder = "";
    fetchFStyles();
  };

  onMount(() => {
    fetchFStyles();
  });


  let header;
  let content;

  $: {
    if (content) {
      content.addEventListener("scroll", () => {
        header.scrollLeft = content.scrollLeft;
      });
    }
  }
</script>

<svelte:head>
  <title>Styles Database | Fabi CC System</title>
</svelte:head>

<Layout>
  {#if $config.currentUser}
    {#if $config.currentUser.department == "Management"}
      <MenuHeading
        title="Styles Database"
        description="Manage the Styles database here."
      />

      <!-- Search Bar -->
      <div class="flex justify-between">
        <div class="flex justify-center">
          <input
            bind:value={searchKey}
            on:input={fetchFStyles}
            class="shadow-sm"
            type="text"
            placeholder="Enter an style name..."
          />
          <button class="ml-2 btn btn-green" on:click={fetchFStyles}>
            <i class="fas fa-search" />
          </button>
        </div>
        <div class="flex items-center">
          <button class="btn btn-blue mr-4" on:click={handleRefresh}>
            <i class="fas fa-undo mr-3" />
            Refresh
          </button>
          <a class="btn btn-green" use:link href="/addfstyle">
            <i class="fas fa-plus-circle mr-3" />
            Add new Styles
          </a>
        </div>
      </div>

      <div
      bind:this={header}
      class="mt-4 sticky-header bg-white overflow-x-scroll text-sm w-full shadow-sm rounded-md"
    >
    <div
    class="th tracking-wider border-b border-gray-100 font-semibold text-gray-600"
  >
    <h1 style="min-width: 18.25rem; max-width: 18.25rem;">Actions</h1>
    <h1
      on:click={() => handleSort("name")}
      class="cursor-pointer"
      style="min-width: 20rem; max-width: 20rem;"
    >
      Name
    </h1>
    <h1
      on:click={() => handleSort("price")}
      class="cursor-pointer"
      style="min-width: 7.5rem; max-width: 7.5rem;"
    >
      Selling Price
    </h1>
    <h1
      class="cursor-pointer mr-4"
      style="min-width: 8rem; max-width: 8rem;"
    >
      Production Cost
    </h1>
    <div
      on:click={() => handleSort("inventoryLevel")}
      class="cursor-pointer"
      style="min-width: 7.5rem; max-width: 7.5rem;"
    >
      In Stock
    </div>
    <div
      on:click={() => handleSort("size")}
      class="cursor-pointer"
      style="min-width: 7.5rem; max-width: 7.5rem;"
    >
      Size
    </div>
    <div
      on:click={() => handleSort("SKU")}
      class="cursor-pointer"
      style="min-width: 10rem; max-width: 10rem;"
    >
      SKU
    </div>
    <div
      on:click={() => handleSort("supplierID")}
      class="cursor-pointer"
      style="min-width: 7.5rem; max-width: 7.5rem;"
    >
      Total Value
    </div>
  </div>

  </div>

      <!-- Products Bar -->
      <div
        class="bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
        bind:this={content}

      >
        {#if products}
          {#each products as prod (prod._id)}
            <FStyleRow {...prod} on:delete={fetchFStyles} />
          {:else}
            <div class="h-52 w-full flex items-center justify-center">
              Nothing to show...
            </div>
          {/each}
        {:else}
          <div class="h-52 w-full flex items-center justify-center">
            <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
          </div>
        {/if}

        <div class="tf">
          <button
            class="text-base btn btn-gray-outline"
            on:click={handlePrevPage}
          >
            <i class="fas fa-arrow-circle-left mr-3" />
            Prev Page
          </button>
          <div class="mx-4">Page {page}</div>
          <button
            class="text-base btn btn-gray-outline"
            on:click={handleNextPage}
          >
            Next Page
            <i class="fas fa-arrow-circle-right ml-3" />
          </button>
        </div>
      </div>
    {/if}
  {/if}
</Layout>


<div class="fixed bottom-2 right-2 flex items-center">
  <button class="text-lg" on:click={() => content.scrollBy(-100, 0)}>
    <i class="fas fa-arrow-circle-left ml-3 text-gray-400" />
  </button>
  <button class="text-lg" on:click={() => content.scrollBy(100, 0)}>
    <i class="fas fa-arrow-circle-right ml-3 text-gray-400" />
  </button>
</div>

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
